class AutoQuantity extends HTMLElement {
  connectedCallback() {
    const productInfo = this.closest('product-info') || document;
    this.quantityElement = productInfo.querySelector('quantity-input input');
    
    this.selects = Array.from(this.querySelectorAll('select'));
    this.event = new Event('change', { bubbles: true });
    
    this.addEventListener('change', this.changeHandler.bind(this));

    // 🚀 优化：初始化时同步数值，确保下拉框与输入框一致
    this.updateQuantity();
    if (this.quantityElement && this.quantity > 0) {
      this.quantityElement.value = this.quantity;
    }
  }
  
  changeHandler(event) {
    // 🛡️ 拦截非人为触发的事件（如代码触发的 change），防止死循环
    if (event && event.isTrusted === false) return;

    this.updateQuantity();
    this.setQuantity();
    
    if (this.quantityElement) {
      this.quantityElement.dispatchEvent(this.event);
    }
  }

  updateQuantity() {
    this.quantity = this.selects.reduce((acc, select) => {
        const step = parseInt(select.dataset.value, 10) || 0;
        const val = parseInt(select.value, 10) || 0;
        return acc + (val * step);
    }, 0);
  }
  
  setQuantity() {
    if (this.quantityElement) {
      this.quantityElement.value = this.quantity;
    }
  }
}

if (!customElements.get('quantity-selects')) {
  customElements.define('quantity-selects', AutoQuantity);
}
